import { render, staticRenderFns } from "./pdf2.vue?vue&type=template&id=f42520a4&scoped=true&"
import script from "./pdf2.vue?vue&type=script&lang=js&"
export * from "./pdf2.vue?vue&type=script&lang=js&"
import style0 from "./pdf2.vue?vue&type=style&index=0&id=f42520a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f42520a4",
  null
  
)

export default component.exports